// removed by extract-text-webpack-plugin
module.exports = {"rupee-sign":"_3Rkz","has-val":"_2p0b","pos-r":"_3n1G","amt-label":"_2Yi6","quantity":"_1-J7","ibl":"_2bNr","tr":"_3Y9B","clear":"_1UiP","link-btn":"_2sRQ","mult":"_2XI8","info":"_2WO3"};


//////////////////
// WEBPACK FOOTER
// ./form/components/inputs/quantity-amount/style.css
// module id = jUR6
// module chunks = 4